var map = {
	"./airplane.svg": 628,
	"./angle-down.svg": 6188,
	"./angle-left.svg": 219,
	"./angle-right.svg": 9214,
	"./arrow-left.svg": 1293,
	"./back.svg": 8767,
	"./backward.svg": 6033,
	"./bell.svg": 8313,
	"./bookmark.svg": 9482,
	"./burger.svg": 3809,
	"./calendar.svg": 3912,
	"./circle-minus.svg": 8961,
	"./circle-plus.svg": 6995,
	"./clock.svg": 4984,
	"./close.svg": 7758,
	"./comments.svg": 8280,
	"./crown.svg": 5139,
	"./d-plius.svg": 9912,
	"./door.svg": 7638,
	"./envelope.svg": 2154,
	"./forecast-cloud.svg": 9145,
	"./forward.svg": 1337,
	"./gallery-border.svg": 4323,
	"./gallery.svg": 9160,
	"./group.svg": 3043,
	"./home.svg": 1395,
	"./info-circle.svg": 2815,
	"./issue-toc.svg": 1914,
	"./link.svg": 954,
	"./listen.svg": 4011,
	"./live.svg": 6836,
	"./microphone.svg": 9870,
	"./mobile.svg": 9352,
	"./most-bought.svg": 9913,
	"./news-paper.svg": 3882,
	"./next.svg": 2441,
	"./pause.svg": 992,
	"./pc.svg": 5841,
	"./play.svg": 7464,
	"./plus.svg": 2086,
	"./prev.svg": 6441,
	"./print.svg": 171,
	"./question-bubble.svg": 3377,
	"./saugu.svg": 7563,
	"./search.svg": 5426,
	"./share.svg": 3607,
	"./social-envelope.svg": 8876,
	"./social-facebook-circle.svg": 6961,
	"./social-facebook.svg": 2308,
	"./social-instagram.svg": 9876,
	"./social-linkedin.svg": 7214,
	"./social-messenger.svg": 9013,
	"./social-twitter.svg": 5109,
	"./social-vk.svg": 8121,
	"./speed.svg": 5043,
	"./success.svg": 5611,
	"./text-size.svg": 435,
	"./tick.svg": 6065,
	"./total-package.svg": 5327,
	"./trash.svg": 4636,
	"./trending.svg": 7949,
	"./user-picture.svg": 1258,
	"./user.svg": 6835,
	"./warning.svg": 2918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6913;